/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1MotiPayload
 */
export interface V1MotiPayload {
    /**
     *
     */
    count: number
    /**
     *
     */
    from: string
    /**
     *
     */
    to: string
    /**
     *
     */
    emotion: string
    /**
     *
     */
    message?: string
    /**
     *
     */
    photo?: string
}

/**
 * Check if a given object implements the V1MotiPayload interface.
 */
export function instanceOfV1MotiPayload(value: object): value is V1MotiPayload {
    if (!('count' in value) || value['count'] === undefined) return false
    if (!('from' in value) || value['from'] === undefined) return false
    if (!('to' in value) || value['to'] === undefined) return false
    if (!('emotion' in value) || value['emotion'] === undefined) return false
    return true
}

export function V1MotiPayloadFromJSON(json: any): V1MotiPayload {
    return V1MotiPayloadFromJSONTyped(json, false)
}

export function V1MotiPayloadFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1MotiPayload {
    if (json == null) {
        return json
    }
    return {
        count: json['count'],
        from: json['from'],
        to: json['to'],
        emotion: json['emotion'],
        message: json['message'] == null ? undefined : json['message'],
        photo: json['photo'] == null ? undefined : json['photo']
    }
}

export function V1MotiPayloadToJSON(json: any): V1MotiPayload {
    return V1MotiPayloadToJSONTyped(json, false)
}

export function V1MotiPayloadToJSONTyped(
    value?: V1MotiPayload | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        count: value['count'],
        from: value['from'],
        to: value['to'],
        emotion: value['emotion'],
        message: value['message'],
        photo: value['photo']
    }
}
